import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star, Quote, ExternalLink } from "lucide-react";

import { getBusinessDetails } from "./services/googlePlaces";



export default function Testimonials() {
    const GoogleSite = process.env.REACT_APP_GOOGLE_WEBSTIE_REV;
    const [testimonials, setTestimonials] = useState([]);
const [rating, setRating] = useState(0);
const [reviewCount, setReviewCount] = useState(0);
const [loading, setLoading] = useState(true);

useEffect(() => {
  async function loadGoogleReviews() {
    try {
      const data = await getBusinessDetails();

      console.log("Google Response:", data);

      setRating(data.rating || 0);
      setReviewCount(data.userRatingCount || 0);

      if (data.reviews) {
        const googleReviews = data.reviews.map((review, index) => ({
          id: index,

          name:
            review.authorAttribution?.displayName ??
            "Google User",

          company: "Google Review",

          review:
            review.text?.text ??
            "No review available.",

          rating:
            review.rating ?? 5,

          photo:
            review.authorAttribution?.photoUri ?? "",
        }));

        setTestimonials(googleReviews);
      }
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  }

  loadGoogleReviews();
}, []);

    if (loading) {
    return (
        <section className="py-32 text-center">
        <h2 className="text-3xl font-bold text-[#2C2C2C]">
            Loading Google Reviews...
        </h2>
        </section>
    );
    }
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-[#EEF8FF] via-white to-[#F8F3ED] py-28 px-6">

      {/* Background Decorations */}

      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-[#D4AF37]/10 blur-3xl"></div>

      <div className="absolute bottom-0 left-0 w-[450px] h-[450px] rounded-full bg-[#A8D5FF]/20 blur-3xl"></div>

      <div className="relative z-10 max-w-7xl mx-auto">

        {/* Header */}

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: .7 }}
          viewport={{ once: true }}
          className="text-center"
        >

          <span className="uppercase tracking-[6px] text-[#D4AF37] font-semibold">
            Testimonials
          </span>

          <h2 className="text-5xl lg:text-6xl font-bold text-[#2C2C2C] mt-6">
            Trusted By
            <br />
            Our Clients
          </h2>

          <div className="w-24 h-1 bg-[#D4AF37] rounded-full mx-auto my-8"></div>

          <p className="text-lg text-gray-600 leading-9 max-w-3xl mx-auto">
            Every business relationship is built on trust. Here's what our
            clients have to say about working with Pure Business Solutions.
          </p>

          <div className="flex justify-center items-center gap-3 mt-10">

            <div className="flex gap-1">

              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  size={26}
                  className="fill-[#D4AF37] text-[#D4AF37]"
                />
              ))}

            </div>

            <span className="text-xl font-bold text-[#2C2C2C]">
            {rating} ★ ({reviewCount} Google Reviews)
            </span>

          </div>

        </motion.div>

        {/* Cards */}

        <div className="grid lg:grid-cols-3 gap-8 mt-20">

          {testimonials.map((review, index) => (

            <motion.div
              key={review.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: .5,
                delay: index * .15,
              }}
              viewport={{ once: true }}
              className="
              bg-white
              rounded-[32px]
              shadow-xl
              p-10
              relative
              hover:-translate-y-2
              hover:shadow-2xl
              transition-all
              duration-300
              "
            >

              <Quote
                className="absolute top-8 right-8 text-[#D4AF37]/20"
                size={60}
              />

              <div className="flex gap-1 mb-6">

                {[...Array(review.rating)].map((_, i) => (

                  <Star
                    key={i}
                    size={20}
                    className="fill-[#D4AF37] text-[#D4AF37]"
                  />

                ))}

              </div>

              <p className="text-gray-600 leading-8 italic">
                "{review.review}"
              </p>

                <div className="flex items-center gap-4 mt-8">

                {review.photo ? (
                    <img
                    src={review.photo}
                    alt={review.name}
                    className="w-14 h-14 rounded-full object-cover"
                    />
                ) : (
                    <div className="w-14 h-14 rounded-full bg-[#D4AF37] flex items-center justify-center text-white font-bold">
                    {review.name.charAt(0)}
                    </div>
                )}

                <div>
                    <h3 className="font-bold text-xl text-[#2C2C2C]">
                    {review.name}
                    </h3>

                    <p className="text-gray-500">
                    Google Review
                    </p>
                </div>

                </div>

            </motion.div>

          ))}

        </div>

        {/* Google Button */}

        <div className="text-center mt-20">

          <a
            href= {GoogleSite}
            target="_blank"
            rel="noopener noreferrer"
            className="
            inline-flex
            items-center
            gap-3
            rounded-full
            bg-[#D4AF37]
            hover:bg-[#BE9924]
            text-white
            px-10
            py-5
            text-lg
            font-bold
            shadow-xl
            hover:scale-105
            transition-all
            duration-300
            "
          >
            View All Google Reviews

            <ExternalLink size={20} />

          </a>

        </div>

      </div>

    </section>
  );
}